// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.formik-error__message {
  color: var(--danger);
}

.formik-field__error, .formik-field__error:active, .formik-field__error:focus {
  border-color: var(--danger);
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/containers/App/styles/form.css","webpack://./services/frontend/app/containers/App/styles/form.css"],"names":[],"mappings":"AADA;ECEE,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;AAC7B","sourcesContent":[".formik-error__message {\n  color: var(--danger);\n}\n\n.formik-field__error {\n  border-color: var(--danger);\n}\n\n.formik-field__error:active,\n  .formik-field__error:focus {\n    border-color: var(--danger);\n  }\n",".formik-error__message {\n  color: var(--danger);\n}\n\n.formik-field__error, .formik-field__error:active, .formik-field__error:focus {\n  border-color: var(--danger);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
